import { getApiUrlString, setUrlMap } from '../../modules/get_apiUrlString'
import { getCode } from '../../modules/get_code'

console.log('round_common_process.js')
const urlMap = {};

export default async (initData) => {

  Object.assign(urlMap, initData);
  setUrlMap(urlMap);

  const data = {}
  const init = async () => {
    // クエリにシリーズの指定がない時
    //   APIから取得したcurrent_seriesで特定
    // クエリにシリーズの指定がある時
    //   クエリのseriesを使用
    const currentYearResultPromise = await fetch(getApiUrlString('year'))
      .then(res => res.json())
      .then(res => {
        return {
          year: urlMap.queryObject.year
            ? urlMap.queryObject.year
            : res.data.current_promoter_year,
          season: urlMap.queryObject.season
            ? urlMap.queryObject.season
            : res.data.current_season
        }
      })
    const seasonYear2Digit = currentYearResultPromise.year % 1000;
    // ページタイトル用データの生成
    const pageData = {
      year: currentYearResultPromise.year,
      yearTxt: `${seasonYear2Digit}-${seasonYear2Digit + 1}`,
      season: currentYearResultPromise.season
    }
    console.log(`currentYearResultPromise`, currentYearResultPromise);

    const seasonResultPromise =  await fetch(getApiUrlString('season'))
      .then(res => res.json())
      .then(res => res.data.scheduled_seasons.map(seasonObj => {
        seasonObj.title = getCode('seasonText', seasonObj.season).ja;
        seasonObj.isCurrent = pageData.season == seasonObj.season;
        return seasonObj
      }))
    console.table(`seasonResultPromise`, seasonResultPromise);
    // seasonResultPromise.pop();

    // 開催年、シリーズによるラウンド情報の取得
    const roundQueryString = `?promoter_year=${currentYearResultPromise.year}&season=${currentYearResultPromise.season}`
    // console.log(`roundQueryString`, roundQueryString)
    const roundResultPromise = await fetch(getApiUrlString('round', roundQueryString))
      .then(res => res.json())
      .then(res => res.data.round_list.map(roundInfoObj => {
        if (!roundInfoObj.code) {
          roundInfoObj.code = '1';
        }
        roundInfoObj.isDiscontinuation = roundInfoObj.hold_status == 2;
        roundInfoObj.title = getCode('round', roundInfoObj.code).name;
        roundInfoObj.date = `${roundInfoObj.first_day.split(/-|\./).slice(1).join('月')}日 ~ ${calcDateString(roundInfoObj.first_day, (roundInfoObj.hold_days - 1)).split(/-|\./).slice(1).join('月')}日`;
        return roundInfoObj
      }))
      .catch(() => {
        return null;
      });
    console.log(`roundResultPromise`, roundResultPromise);
    if (!roundResultPromise || roundResultPromise.length == 0) {
      Object.assign(data, {
          type: 'error',
          cb: () => {
            postMessage({
              type: 'error',
              data: roundResultPromise
            })
          }
        }
      )
      return;
    }

    // クエリによるround_codeの指定がある場合
    //   round_codeでラウンド情報を特定
    // クエリによるround_codeの指定がない場合
    //   直近のラウンド情報の取得
    //     開催中：現時点のラウンド情報
    //     開催前：次に開催される直近のラウンド情報
    const currentMillSecond = Date.now();
    const currentRoundInfoObj = (() => {
      const filteringRoundObj = roundResultPromise.filter((roundInfoObj, rIdx) => {
        const isCurrent = (() => {
          if (urlMap.queryObject.round_code) {
            return roundInfoObj.code == urlMap.queryObject.round_code;
          } else {
            return isWithinRangeDate(currentMillSecond, roundInfoObj)
            || (!!roundResultPromise[rIdx - 1] && isWithinRangeDate(currentMillSecond, {
              first_day: calcDateString(roundResultPromise[rIdx - 1]["first_day"], roundResultPromise[rIdx - 1]["hold_days"]),
              last_day: roundInfoObj["first_day"]
            }));
          }
        })();
        roundInfoObj.isCurrent = isCurrent;
        return isCurrent;
      }).pop();

      console.log(`filteringRoundObj`, filteringRoundObj);

      return filteringRoundObj
        ? filteringRoundObj
        : (() => {
            // 上記はデータが返ってこなかったときのための暫定処理
            // 日付的に該当するデータがない為、一番最初のラウンドデータをカレントとする
            const roundObj = roundResultPromise[0];
            roundObj.isCurrent = true;
            return roundObj;
          })();
    })();
    console.log('currentRoundInfoObj', currentRoundInfoObj);

    // 開催期間情報
    const currentDateObj = new Date(currentRoundInfoObj.first_day);
    const term = {
      start: {
        date: currentRoundInfoObj.first_day.split('-').slice(1).join('.'),
        week: `${getWeekText(currentDateObj.getDay())}曜日`
      },
      end: {
        date: (() => {
          currentDateObj.setDate(currentDateObj.getDate() + (currentRoundInfoObj.hold_days - 1));
          return currentDateObj.getDate();
        })(),
        week: `${getWeekText(currentDateObj.getDay())}曜日`
      }
    }

    // ページ情報の追記
    Object.assign(pageData, {
      isRoundDiscontinuation: currentRoundInfoObj.hold_status == 2, // ラウンド開催中止の場合にtrue
      roundCode: currentRoundInfoObj.code || 1, // 上記はデータが返ってこなかったときのための暫定処理
      roundName: currentRoundInfoObj.title,
      hasTtResult: currentRoundInfoObj.has_tt_result,
      term
    })

    // トーナメント（1次予選、2次予選、準決勝、決勝）情報の取得
    const tournamentQueryString = `?promoter_year=${currentYearResultPromise.year}&season=${currentYearResultPromise.season}&round_code=${currentRoundInfoObj.code}`
    const tournamentResultPromise = await fetch(getApiUrlString('tournament', tournamentQueryString))
      .then(res => res.json())
      .then(res => res.data.hold_daily_schedule_list.map(schedule => {
        schedule.isTournamentDiscontinuation = schedule.hold_schedule_status == 2;
        schedule.date = `${schedule.event_date.split(/-|\./).slice(1).join('月')}日`;
        return schedule
      }))
      .catch(() => {
        return null
      });
    console.log('tournamentResultPromise', tournamentResultPromise)
    if (!tournamentResultPromise || tournamentResultPromise.length == 0) {
      Object.assign(data, {
          type: 'error',
          cb: () => {
            postMessage({
              type: 'error',
              data: tournamentResultPromise
            })
          }
        }
      )
      return;
    }

    // メインスレッドへの返却用基本データの生成
    const postData = {
      type: 'base',
      page: pageData,
      promote: currentYearResultPromise,
      season: seasonResultPromise,
      round: roundResultPromise,
      tournament: tournamentResultPromise
    };

    Object.assign(data, postData);
  }

  await init();

  return data;
}


// 日付データ文字列生成
const calcDateString = (dateStr, holdDays) => {
  const dateObj = new Date(dateStr);
  dateObj.setHours(0, 0, 0);
  dateObj.setDate(dateObj.getDate() + Number(holdDays))
  return [dateObj.getFullYear(), `0${dateObj.getMonth() + 1}`.slice(-2), `0${dateObj.getDate()}`.slice(-2)].join('-');
}
// 日付データから該当期間に被るかどうかの判定
const isWithinRangeDate = (currentMillsecond, obj) => {
  if (!obj) {
    return false;
  }
  const lowDateObj = new Date(obj["first_day"]);
  lowDateObj.setHours(0, 0, 0);
  const lowMillSecond = lowDateObj.getTime();
  const higDateObj = (() => {
    if (obj["hold_days"]) {
      const dateObj = new Date(obj["first_day"]);
      dateObj.setHours(0, 0, 0);
      dateObj.setDate(dateObj.getDate() + Number(obj["hold_days"]))
      return dateObj;
    } else {
      const dateObj = new Date(obj["last_day"]);
      dateObj.setHours(0, 0, 0);
      return dateObj;
    }
  })();
  const highMillSecond = higDateObj.getTime();
  return lowMillSecond < currentMillsecond && currentMillsecond < highMillSecond;
}
// 曜日テキスト取得
const getWeekText = (dayNum) => {
  const weekMap = [
    '日', '月', '火', '水', '木', '金', '土'
  ]
  return weekMap[dayNum];
}
